/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { Alert, Box, Button, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason, alpha, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { VTextField, VForm, useVForm, IVFormErrors, VFieldMoneyNumber2, AutoCompleteMunicipio, SelectNumber, VTextFieldCpfCnpj, VTextFieldPassword, AutoCompleteOperacoes, AutoCompleteOperacoes01, AutoCompleteParceiro, AutoCompletePlanoDeContas01, AutoCompleteContaBancaria, AutoCompletePlanoDeContas, VSwitch, VTextFieldNumber } from '../../../shared/forms';
import { FerramentasDeDetalhe } from '../../../shared/components';
import { LayoutBaseDePaginaColaborador } from '../../../shared/layouts';
import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import { ProdutorService } from '../../../shared/services/api/cadastros/ProdutorService';
import { EmpresaService } from '../../../shared/services/api/cadastros/Empresa';

type NullableDate = Date | null | undefined;
interface IFormData {
  idempresa: string;
  nome: string;
  cnpj: string;
  fantasia: string;
  endereco: string;
  numero: string;
  bairro: string;
  idmunicipio: string;
  uf: string;
  cep: string;
  telefone: string;
  cnae: number;
  crt: number;
  ie: string;
  csc: string;
  cscid: string;
  certificado: string;
  logo: string;
  serie55: number;
  serie65: number;
  tpamb: number;
  senha: string;
  decimais: number;
  refs: boolean;
  tipoimp: number;
  margem: number;
  est: boolean;
}
const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'idempresa' | 'logo' | 'certificado'>> = yup.object().shape({
  nome: yup.string().required(),
  cnpj: yup.string().required(),
  fantasia: yup.string().required(),
  endereco: yup.string().required(),
  numero: yup.string().required(),
  margem: yup.number().required(),
  bairro: yup.string().required(),
  idmunicipio: yup.string().required(),
  uf: yup.string().required(),
  cep: yup.string().required(),
  telefone: yup.string().required(),
  cnae: yup.number().required(),
  crt: yup.number().required(),
  ie: yup.string().required(),
  csc: yup.string().required(),
  cscid: yup.string().required(),
  serie55: yup.number().required(),
  serie65: yup.number().required(),
  tpemis: yup.number().required(),
  tpamb: yup.number().required(),
  senha: yup.string().required(),
  decimais: yup.number().required(),
  refs: yup.boolean().required().default(false),
  tipoimp: yup.number().required().default(2),
  est: yup.boolean().required().default(false),
});
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
  backgroundColor: theme.palette.background.paper,
}));

const ModernLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 3,
  marginBottom: theme.spacing(2),
}));

const RoundedTextField = styled(VTextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.secondary,
  },
}));
const SectionBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: '12px',
  backgroundColor: theme.palette.mode === 'dark'
    ? alpha(theme.palette.background.default, 0.5)
    : alpha('#f5f5f5', 0.3),
  marginBottom: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
}));
const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingLeft: 0,
  paddingRight: 0,
  marginLeft: 0,
  marginRight: 0,
  width: '100%',
  maxWidth: '100%',
}));

export const DetalheDeEmpresa: React.FC = () => {
  const theme = useTheme();
  const [urlimg, setUrlimg] = useState('');
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();
  const { formRef, save, saveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState<string | null>(null);
  const [selectedImage, setSelectedImage] = useState<File | undefined>();
  const [selectedCert, setSelectedCert] = useState<File | undefined>();
  const [certificado, setcertificado] = useState('');
  const [idempresa, setId] = useState('');
  const [nome, setNome] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      navigate('/empresa');
    }
  };
  const handleDelete = () => {
    setOpenConfirm(true);
  };
  useEffect(() => {
    return () => {
      if (image?.startsWith('blob:')) {
        URL.revokeObjectURL(image);
      }
    };
  }, [image]);
  const handleConfirmDelete = () => {
    ProdutorService.deleteById(id)
      .then(result => {
        if (result instanceof Error) {
          setOpenConfirm(false);
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setOpenConfirm(false);
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
        }
      });
  };

  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };

  useEffect(() => {

    setIsLoading(true);
    EmpresaService.getById()
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setNome(result.nome);
          setId(result.idempresa)
          setUrlimg(result.logo);
          setImage(window.env.REACT_APP_URL_IMGLOG + result.logo);
          setcertificado(result.certificado);
          formRef.current?.setData(result);
        }
      });
  }, [id]);

  const handleSave = (dados: IFormData) => {
    const { logo, ...dadosSemCampos } = dados;
    formValidationSchema
      .validate(dadosSemCampos, { abortEarly: false })
      .then(async () => {
        setIsLoading(true);
        const result = await EmpresaService.updateById(idempresa, dados);
        if (result instanceof Error) {
          setIsLoading(false);
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
          return;
        }
        if (selectedImage) {
          const imgResult = await EmpresaService.updateByIdImg(
            idempresa,
            selectedImage,
            urlimg
          );
          if (imgResult instanceof Error) {
            setIsLoading(false);
            setTms('error');
            setMsg(imgResult.message);
            setOpenmsg(true);
            return;
          }
        }
        if (selectedCert) {
          const certResult = await EmpresaService.updateByIdCert(
            idempresa,
            selectedCert,
            certificado
          );
          if (certResult instanceof Error) {
            setIsLoading(false);
            setTms('error');
            setMsg(certResult.message);
            setOpenmsg(true);
            return;
          }
        }
        setIsLoading(false);
        setTms('success');
        setMsg('Alteração concluída com sucesso!');
        setOpenmsg(true);
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });

        formRef.current?.setErrors(validationErrors);
      });
  };

  return (
    <LayoutBaseDePaginaColaborador
      barraDeFerramentas={
        <FerramentasDeDetalhe
          textoBotaoNovo='Novo'
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoSalvarCarregando={false}
          mostrarBotaoSalvarEFecharCarregando={isLoading}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoApagar={id !== 'novo'}
          mostrarBotaoApagarCarregando={isLoading}
          mostrarBotaoImpressao={false}
          mostrarBotaoHistorico={false}
          mostrarBotaoferais={false}
          mostrarBotaoauxilio={false}
          mostrarBotaoHistoricoCarregando={false}
          mostrarBotaoferaisCarregando={isLoading}
          mostrarBotaoauxilioCarregando={isLoading}
          mostrarBotaoCartaoPonto={false}
          mostrarBotaoCartaoPontoCarregando={isLoading}
          mostrarBotaoCartaoPontoVerso={false}
          mostrarBotaoCartaoPontoVersoCarregando={isLoading}
          aoClicarEmSalvar={save}
          aoClicarEmVoltar={() => navigate('/produtos')}
          mostrarBotaoVoltarCarregando={isLoading}
          aoClicarEmApagar={() => handleDelete()}
          aoClicarEmNovo={() => navigate('/produto/novo')}
          mostrarBotaoNovoCarregando={isLoading}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{
              width: '100%',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
            }}
          >
            {msg}
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="warning"
            variant="filled"
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
            }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                  Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDelete}>
                  Nâo
                </Button>
              </>
            }
          >
            Tem certeza que deseja excluir este registro?
          </Alert>
        </Snackbar>
        <ContentContainer>
          <StyledPaper elevation={0} sx={{ marginLeft: 0, marginRight: 0 }}>
            <Grid container direction="column" spacing={3}>
              {isLoading && (
                <Grid item>
                  <ModernLinearProgress variant='indeterminate' />
                </Grid>
              )}
              <Grid item>
                <SectionBox>
                  <Grid container spacing={2} alignItems="center" >
                    <Grid item xs={12} sm={12} md={2.5} lg={3} xl={3}>
                      <Box width="100%" display="flex" justifyContent="center">
                        <input
                          id="avatar-input"
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(event) => {
                            const file = event.target.files?.[0];
                            if (!file) return;
                            setSelectedImage(file);
                            const preview = URL.createObjectURL(file);
                            setImage(preview);
                          }}
                        />
                        <label htmlFor="avatar-input" style={{ cursor: 'pointer', width: '100%' }}>
                          <Box
                            sx={{
                              width: '100%',
                              aspectRatio: '1 / 1',
                              borderRadius: '12px',
                              backgroundColor:
                                theme.palette.mode === 'dark' ? '#424242' : '#f5f5f5',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              overflow: 'hidden',
                            }}
                          >
                            {image ? (
                              <Box
                                component="img"
                                src={image}
                                alt="logo"
                                sx={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'contain',
                                }}
                              />
                            ) : (
                              <Avatar variant="rounded" sx={{ width: '100%', height: '100%', backgroundColor: 'transparent' }} />
                            )}
                          </Box>
                        </label>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={9.5} lg={9} xl={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='nome'
                            disabled={isLoading}
                            label='Nome'
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='fantasia'
                            disabled={isLoading}
                            label='Fantasia'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
                          <VTextFieldCpfCnpj
                            fullWidth
                            size='small'
                            name='cnpj'
                            disabled={true}
                            label='CNPJ'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='ie'
                            disabled={true}
                            label='INSC. ESTADUAL'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='telefone'
                            disabled={isLoading}
                            label='Telefone'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='endereco'
                            disabled={isLoading}
                            label='Endereço'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='numero'
                            disabled={isLoading}
                            label='Numero'
                          />
                        </Grid><Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='bairro'
                            disabled={isLoading}
                            label='Bairro'
                          />
                        </Grid><Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          <AutoCompleteMunicipio
                          />
                        </Grid>

                        <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='uf'
                            disabled={isLoading}
                            label='UF'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                          <RoundedTextField
                            fullWidth
                            size="small"
                            name="cep"
                            disabled={isLoading}
                            label="CEP"
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                          <input
                            id="cert-input"
                            type="file"
                            accept=".pfx"
                            hidden
                            onChange={(event) => {
                              const file = event.target.files?.[0];
                              if (!file) return;
                              setSelectedCert(file);
                            }}
                          />
                          <label htmlFor="cert-input">
                            <Button
                              fullWidth
                              variant="outlined"
                              component="span"
                              disabled={isLoading}
                              sx={{
                                height: '40px',
                                borderRadius: '12px',
                                justifyContent: 'space-between',
                                textTransform: 'none',
                              }}
                            >
                              {selectedCert ? selectedCert.name : 'Certificado (.pfx)'}
                            </Button>
                          </label>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                          <VTextFieldPassword
                            fullWidth
                            size='small'
                            name='senha'
                            disabled={isLoading}
                            label='Senha'
                            autoComplete="new-password"
                            inputProps={{
                              autoComplete: 'new-password',
                              'data-lpignore': 'true',
                              'data-1p-ignore': 'true',
                            }}
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                          <SelectNumber
                            name='decimais'
                            label='Casas Decimais'
                            data={[
                              { nameBD: 2, descricao: '2' },
                              { nameBD: 4, descricao: '4' },

                            ]}
                            disabled={isLoading}
                          />
                        </Grid>
                        <Grid item xs={3} sm={3} md={2} lg={2} xl={2}>
                          <SelectNumber
                            name='tipoimp'
                            label='tipo de impressão'
                            data={[
                              { nameBD: 1, descricao: '1' },
                              { nameBD: 2, descricao: '2' },

                            ]}
                            disabled={isLoading}
                          />
                        </Grid>
                        <Grid item xs={3} sm={3} md={2} lg={2} xl={2}>
                          <VTextFieldNumber
                            fullWidth
                            size='small'
                            name='margem'
                            disabled={isLoading}
                            label='Margem de Lucro (%)'
                          />
                          <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                          </Grid>
                          <VSwitch
                            name='refs'
                            label='Referência'
                            fdisabled={isLoading}
                            aliamento='start'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                          <VSwitch
                            name='est'
                            label='Estoque'
                            fdisabled={isLoading}
                            aliamento='start'
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </SectionBox>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 0 }} marginLeft={0} marginTop={0}>
                <Grid item xs={12} md={12} xl={12}>
                  <SectionBox>
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                        <VFieldMoneyNumber2
                          fullWidth
                          size='small'
                          name='cnae'
                          label='CNAE'
                          disabled={false}
                        />
                      </Grid> <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                        <SelectNumber
                          name='tpemis'
                          label='Tipo de Emissão'
                          data={[
                            { nameBD: 1, descricao: 'Emissão normal (não em contingência)' },
                            { nameBD: 2, descricao: 'Contingência FS-IA, com impressão do DANFE em formulário de segurança' },
                            { nameBD: 3, descricao: 'Contingência SCAN (Sistema de Contingência do Ambiente Nacional)' },
                            { nameBD: 4, descricao: 'Contingência DPEC (Declaração Prévia da Emissão em Contingência)' },
                            { nameBD: 5, descricao: 'Contingência FS-DA, com impressão do DANFE em formulário de segurança' },
                            { nameBD: 6, descricao: 'Contingência SVC-AN (SEFAZ Virtual de Contingência do AN)' },
                            { nameBD: 7, descricao: 'Contingência SVC-RS (SEFAZ Virtual de Contingência do RS)' },
                          ]}
                          disabled={isLoading}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                        <SelectNumber
                          name='tpamb'
                          label='Tipo de Emissão'
                          data={[
                            { nameBD: 1, descricao: 'Produção' },
                            { nameBD: 2, descricao: 'Homologação' },
                          ]}
                          disabled={isLoading}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                        <SelectNumber
                          name='crt'
                          label='CRT Empresa'
                          data={[
                            { nameBD: 1, descricao: 'Simples Nacional' },
                            { nameBD: 2, descricao: 'Simples Nacional - excesso de sublimite da receita bruta' },
                            { nameBD: 3, descricao: 'Regime Normal' },
                          ]}
                          disabled={isLoading}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={1} lg={1} xl={1}>
                        <RoundedTextField
                          fullWidth
                          size='small'
                          name='csc'
                          disabled={isLoading}
                          label='CSC'
                        />
                      </Grid>
                      <Grid item xs={3} sm={3} md={1} lg={1} xl={1}>
                        <VFieldMoneyNumber2
                          fullWidth
                          size='small'
                          name='serie55'
                          label='Serie 55'
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={3} sm={3} md={1} lg={1} xl={1}>
                        <VFieldMoneyNumber2
                          fullWidth
                          size='small'
                          name='serie65'
                          label='Serie 65'
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                        <RoundedTextField
                          fullWidth
                          size='small'
                          name='cscid'
                          disabled={isLoading}
                          label='CSCID'
                        />
                      </Grid>
                    </Grid>
                  </SectionBox>
                </Grid>
              </Grid>
            </Grid>
          </StyledPaper>
        </ContentContainer>
      </VForm >
    </LayoutBaseDePaginaColaborador >
  );
};